<template>
  <form @submit.prevent="onSubmit">
    <div class="mb-3">
      <label class="form-label">{{ t('settings.areas.fields.name') }}</label>

      <div class="input-group input-group-sm">
        <span class="input-group-text bg-white border-end-0">
          <i class="fas fa-map-marker-alt text-muted"></i>
        </span>
        <input
          type="text"
          class="form-control border-start-0"
          :class="{ 'is-invalid': serverErrors.name }"
          v-model.trim="model.name"
          required
          :placeholder="t('settings.areas.placeholders.name')"
        />
      </div>

      <div class="invalid-feedback d-block" v-if="serverErrors.name">
        {{ serverErrors.name[0] }}
      </div>
    </div>
  </form>
</template>

<script setup>
import { reactive, ref, watchEffect, defineProps, defineEmits, defineExpose } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
  initialData: { type: Object, default: () => ({ name: '' }) }
})
const emit = defineEmits(['submit', 'validation-error'])

const serverErrors = ref({})
const model = reactive({ name: '' })

watchEffect(() => {
  serverErrors.value = {}
  model.name = props.initialData?.name ?? ''
})

const setServerErrors = (errs) => { serverErrors.value = errs || {} }

const submit = () => {
  serverErrors.value = {}
  if (!model.name) { emit('validation-error'); return }
  emit('submit', { name: model.name })
}

const onSubmit = () => submit()

defineExpose({ submit, setServerErrors })
</script>
